import React from 'react';
import { BandMember } from '../Band.interface';
import './SingleBandMember.css';
import { Link } from 'react-router-dom';
import { environments } from 'environments/environments';

export default class SingleBandMember extends React.Component {
  state = {
    member: undefined as BandMember | undefined
  }

  componentDidMount() {
    this.getMemberData();
  }

  getMemberData() {
    fetch(environments.serverURL + '/data/band_members.json')
      .then(async response => {
        const data: BandMember[] = await response.json();
        const memberName = (this.props as any).match.params.member;
        // console.log(memberName);
        const member = data.find(memb => memb.link === memberName);
        // console.log(member);
        if (member) {
          this.setState({ member });
        }
        // TODO: Display error message to user when member not found
      })
      // TODO: Display error message to user when members not loaded
      .catch(e => console.error('Detaily člena kapely se nepovedlo načíst.\n', e));
  }

  render() {
    const member = this.state.member;
    const renderInstruments = member
      ? member.instrument.map(instrument => <p className="band-member-info" key={instrument}>{instrument}</p>)
      : null;
    const renderImages = member && member.images
      ? member.images.map(image => <img className="band-member-image" key={image} src={image} alt={member.name} />)
      : null;
    return (
      <div className="section single-band-member">
        <Link to={'/kapela'} className="band-link-back">&larr; Zpět na seznam</Link>
        {member && member.name
          ? (
            <div>
              <div className="band-member-images">
                {renderImages}
              </div>
              <p className="band-member-info-header">Jméno:</p>
              <p className="band-member-info">{member.name}</p>
              <p className="band-member-info-header">Datum a místo narození:</p>
              <p className="band-member-info">{member.birth}</p>
              <p className="band-member-info-header">Stav:</p>
              <p className="band-member-info">{member.status}</p>
              <p className="band-member-info-header">Děti:</p>
              <p className="band-member-info">{member.children}</p>
              <p className="band-member-info-header">V kapele od:</p>
              <p className="band-member-info">{member.since}</p>
              <p className="band-member-info-header">Předtím:</p>
              <p className="band-member-info">{member.before}</p>
              <p className="band-member-info-header">Oblíbená muzika:</p>
              <p className="band-member-info">{member.music}</p>
              <p className="band-member-info-header">Oblíbený sport:</p>
              <p className="band-member-info">{member.sport}</p>
              <p className="band-member-info-header">Oblíbené jídlo:</p>
              <p className="band-member-info">{member.food}</p>
              <p className="band-member-info-header">Oblíbené pití:</p>
              <p className="band-member-info">{member.drink}</p>
              <p className="band-member-info-header">Jiné zájmy:</p>
              <p className="band-member-info">{member.other}</p>
              <p className="band-member-info-header">Nástroj a aparatura:</p>
              {renderInstruments}
              <p className="band-member-info-header">Kontakt:</p>
              <p className="band-member-info">{member.contact}</p>
            </div>
          )
          : null
        }
      </div>
    );
  }
}